export default "__VITE_ASSET__Di1NHf17__"